import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-register-step-pay-progress',
  templateUrl: './register-step-pay-progress.component.html',
  styleUrls: ['./register-step-pay-progress.component.scss'],
})
export class RegisterStepPayProgressComponent implements OnInit {
  constructor(private spinner: NgxSpinnerService) {}

  ngOnInit() {
    this.spinner.show();
  }
}
